import useAlias from '@alias';

function EventTypeCell({ isActive }: { isActive: boolean }) {
  const alias = useAlias();
  return (
    <span className={isActive ? 'bold-red' : ''}>
      {isActive ? alias('Alert On') : alias('Alert Off')}
    </span>
  );
}

export default EventTypeCell;
